import { createAction, props } from '@ngrx/store';

export const setKmDistance = createAction(
  '[Shipping] Set KM Distance',
  props<{ distance: string }>()
);

export const setShippingCost = createAction(
  '[Shipping] Set Shipping Cost',
  props<{ cost: string }>()
);

export const setMountForDelivery = createAction(
  '[Shipping] Set Mount For Delivery',
  props<{ mount: string }>()
);

export const setDeliveryPercent = createAction(
  '[Shipping] Set Delivery Percent',
  props<{ percent: string }>()
);

export const setTotalCost = createAction(
  '[Shipping] Set Total Cost',
  props<{ totalCost: string }>()
);

export const setTime = createAction(
  '[Shipping] Set Time',
  props<{ time: string }>()
);

export const setDeliveryTip = createAction(
  '[Shipping] Set Delivery Tip',
  props<{ tip: string }>()
);
export const setPhoneEstablishment = createAction(
  '[Shipping] Set Phone Establishment',
  props<{ phone: string }>()
);

export const resetShipping = createAction(
  '[Shipping] Reset Shipping'
);

export const setTarifaBase = createAction(
  '[Shipping] Set Tarifa Base',
  props<{ tarifaBase: string }>()
);

export const setTarifaServicio = createAction(
  '[Shipping] Set Tarifa Servicio',
  props<{ tarifaServicio: string }>()
);
export const SetDistanceKm = createAction(
  '[Shipping] Set Distance KM',
  props<{ distanceKm: string }>()
);
